// src/oura/components/newscan/Muted.tsx
//
// Quiet text for the New scan steps: hints, sources, fine print. One place
// for the size and ink, so a hint never drifts to its own grey.
//
// tone "ink3" (gray-500) for hints and status, "ink4" (gray-400) for sources
// and fine print. `as="p"` for a line of its own, a span otherwise.

import type { ReactNode } from "react";
import { cn } from "@oura/lib/cn";
import { TYPE } from "@oura/ui";

export interface MutedProps {
    children: ReactNode;
    tone?: "ink3" | "ink4";
    /** 13px (default) or 12px fine print. */
    size?: "tc" | "tm";
    as?: "span" | "p";
    id?: string;
    className?: string;
}

export function Muted({ children, tone = "ink3", size = "tc", as = "span", id, className }: MutedProps) {
    const cls = cn(size === "tm" ? TYPE.tm : TYPE.tc, tone === "ink4" ? "text-gray-400" : "text-gray-500", as === "p" && "m-0", className);
    return as === "p" ? (
        <p id={id} className={cls}>
            {children}
        </p>
    ) : (
        <span id={id} className={cls}>
            {children}
        </span>
    );
}
